import React, { useContext, useEffect, useState } from 'react';
import LoadingSpinner from 'src/components/common/ui/loader/LoadingSpinner';
import { AuthContext } from 'src/contexts';
import { useHttp } from 'src/hooks';

interface Props {
  selectedBusiness: string | null;
  onSelectBusiness: (accountId: string) => void;
  setIsStepValid: (isValid: boolean) => void;
}

const ChooseBusinessAccount: React.FC<Props> = ({ setIsStepValid,selectedBusiness, onSelectBusiness }) => {
  const [businessAccounts, setBusinessAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const { sendRequest } = useHttp();
  const { accessToken } = useContext(AuthContext);

  const getBusinessAccounts = () => {
    if (businessAccounts.length > 0) return;
    setLoading(true);

    sendRequest(
      {
        url: `facebook/business-accounts`,
        accessToken,
      },
      data => {
        if (data?.data) {
          setBusinessAccounts(data.data);
        }
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    getBusinessAccounts();
  }, [accessToken]);

 useEffect(() => {
  setIsStepValid(!!selectedBusiness);
}, [selectedBusiness, setIsStepValid]);

  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl max-w-2xl mx-auto">
      <h2 className="text-[28px] text-center font-semibold font-inter text-black mb-8">
        Select Business Portfolio
      </h2>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="py-56 flex flex-wrap gap-4 justify-center">
          {businessAccounts.map(account => (
            <div
              key={account.id}
              className={`flex items-center space-x-4 p-4 border rounded-lg cursor-pointer transition-all
                ${
                  selectedBusiness === account.id
                    ? 'border-blue-500 bg-blue-100'
                    : 'border-gray-300 hover:bg-gray-100'
                }`}
              onClick={() => onSelectBusiness(account.id)}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-gray-700 text-white font-bold rounded-full">
                {account.name.charAt(0).toUpperCase()}
              </div>
              <span className="text-lg font-medium">{account.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChooseBusinessAccount;
